import { render, staticRenderFns } from "./WithdrawRecordList.vue?vue&type=template&id=6dbfe75a&scoped=true&"
import script from "./WithdrawRecordList.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecordList.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecordList.vue?vue&type=style&index=0&id=6dbfe75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbfe75a",
  null
  
)

export default component.exports